import { Injectable } from "@angular/core";
import { AbstractService } from "../core/AbstractService";
import { AgentReq } from "../data/http/requests/agent.req";
import { AgentRes } from "../data/http/responses/agent.res";
import { AppService } from "../core/app.service";
import { HttpClient } from "@angular/common/http";
import { env } from "../../env/env";

@Injectable({
    providedIn: 'root'
})
export class AgentService extends AbstractService<AgentReq, AgentRes> {
    constructor(http: HttpClient, appService: AppService) {
        super(`${env.apiUrl}personne`, http, appService); 
    }
}